import { useEffect, useState } from "react";

const findScrollContainer = (node: HTMLElement | null): HTMLElement | null => {
  let current = node?.parentElement ?? null;
  while (current != null) {
    const { overflowY } = getComputedStyle(current);
    if (overflowY === "auto" || overflowY === "scroll") {
      return current;
    }
    current = current.parentElement;
  }
  return null;
};

export const useIsScrolledToBottom = () => {
  const [listEndNode, setListEndNode] = useState<HTMLDivElement | null>(null);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(true);

  useEffect(() => {
    if (listEndNode == null) {
      return;
    }
    const container = findScrollContainer(listEndNode);
    if (container == null) {
      return;
    }

    const update = () => {
      setIsScrolledToBottom(container.scrollTop + container.clientHeight >= container.scrollHeight - 8);
    };
    update();

    container.addEventListener("scroll", update, { passive: true });
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(container);
    for (const child of container.children) {
      resizeObserver.observe(child);
    }

    return () => {
      container.removeEventListener("scroll", update);
      resizeObserver.disconnect();
    };
  }, [listEndNode]);

  const scrollToBottom = () => {
    const container = findScrollContainer(listEndNode);
    container?.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
  };

  return { isScrolledToBottom, setListEndNode, scrollToBottom };
};
